define(['services/validators'], function(validators) {
    return function() {
        return {
            key: {validator: validators.string},
            /**
             * Sets or returns the value of the `countryCode` option.
             *
             * Represents the country's code.
             *
             * @method countryCode
             * @chainable
             * @param {String} [newValue] 2 or 3 country code letters
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            countryCode: {validator: validators.countryCode, required: true},
            limit: {validator: validators.limit},
            offset: {validator: validators.naturalInteger, name: 'ofs'},
            language: {validator: validators.languageCode},

            /**
             * Sets or returns the value of the `streetNumber` option.
             *
             * Represents the street's number for the structured address.
             *
             * @method streetNumber
             * @chainable
             * @param {String} [newValue] Street's number
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            streetNumber: {validator: validators.string},

            /**
             * Sets or returns the value of the `streetName` option.
             *
             * Represents the street's name for the structured address.
             *
             * @method streetName
             * @chainable
             * @param {String} [newValue] Street's name
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            streetName: {validator: validators.string},

            /**
             * Sets or returns the value of the `crossStreet` option.
             *
             * Represents the cross street's name for the structured address.
             *
             * @method crossStreet
             * @chainable
             * @param {String} [newValue] Cross street's name
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            crossStreet: {validator: validators.string},

            /**
             * Sets or returns the value of the `municipality` option.
             *
             * Represents the municipality (city/town) for the structured address.
             *
             * @method municipality
             * @chainable
             * @param {String} [newValue] Municipality's name (city/town)
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            municipality: {validator: validators.string},

            /**
             * Sets or returns the value of the `municipalitySubdivision` option.
             *
             * Represents the municipality subdivision (sub/super city) for the structured address.
             *
             * @method municipalitySubdivision
             * @chainable
             * @param {String} [newValue] Municipality subdivision (sub/super city)
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            municipalitySubdivision: {validator: validators.string},

            /**
             * Sets or returns the value of the `countryTertiarySubdivision` option.
             *
             * Represents the area's name for the structured address.
             *
             * @method countryTertiarySubdivision
             * @chainable
             * @param {String} [newValue] Name of the area
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            countryTertiarySubdivision: {validator: validators.string},

            /**
             * Sets or returns the value of the `countrySecondarySubdivision` option.
             *
             * Represents the county's name for the structured address.
             *
             * @method countrySecondarySubdivision
             * @chainable
             * @param {String} [newValue] County's name
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            countrySecondarySubdivision: {validator: validators.string},

            /**
             * Sets or returns the value of the `countrySubdivision` option.
             *
             * Represents the state or province's name for the structured address.
             *
             * @method countrySubdivision
             * @chainable
             * @param {String} [newValue] State or province
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            countrySubdivision: {validator: validators.string},

            /**
             * Sets or returns the value of the `postalCode` option.
             *
             * Represents the zip code or postal code for the structured address.
             *
             * @method postalCode
             * @chainable
             * @param {String} [newValue] Zip or postal code
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String} The same service instance or the current option value if no argument was given
             */
            postalCode: {validator: validators.string},

            protocol: {validator: validators.oneOfValue(['http', 'https'], 'protocol')},
            bestResult: {validator: validators.bool}
        };
    };
});



// WEBPACK FOOTER //
// ./services/structureGeocode/structureGeocodeParameters.js